import React from "react";

export default function BrandMark({ size = 28, withName = true, sub }) {
  return (
    <div className="flex items-center gap-2.5">
      <svg width={size} height={size} viewBox="0 0 28 28" aria-hidden="true">
        <rect x="0.5" y="0.5" width="27" height="27" rx="5" fill="var(--surface2)" stroke="var(--border-strong)" />
        <path d="M7 20V8l7 7 7-7v12" fill="none" stroke="var(--text)" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        <rect x="18.5" y="18.5" width="3" height="3" fill="var(--accent)" />
      </svg>
      {withName && (
        <div className="leading-tight">
          <p className="text-[14px] font-semibold tracking-[-0.01em]">Mario IA Tech</p>
          {sub && <p className="text-[11px] text-[var(--muted2)]">{sub}</p>}
        </div>
      )}
    </div>
  );
}
